export default class DisabilitySelectionViewModel {
    disabilityId: number | undefined = undefined;
    disabilityDisplay: string = '';
    isPrimary: boolean = false;
}